import React from "react";
import { Container, Button } from "react-bootstrap";
import { useScroll } from "../../../../context/scroll-context";

const DevelopmentHero = () => {

    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };


    return (
        <section className="development hero-section d-flex align-items-center justify-content-center">
            <Container fluid>
                <div className="content-block mb-3">
                    <h2 className="text-white mb-3 ft-wt-700 mb-lg-5 big-title">Development Centre</h2>
                    <div>
                        <Button className="text-uppercase" variant="secondary" onClick={() => handleScrollAndClose(contactform)}>
                            <h5 className="mb-0 text-primary">Apply for free 2 weeks trial</h5>
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default DevelopmentHero;
